import React, { cloneElement } from 'react';
import classNames from 'classnames';
import { makeStyles } from '../styles';
const useStyles = makeStyles(({ palette, spacing }) => ({
    tabRoot: {
        boxSizing: 'border-box',
        display: 'flex',
        height: spacing(3.5),
        color: palette.text.main,
        padding: spacing(0.5, 1),
        backgroundColor: palette.background.default,
        borderTop: `1px solid ${palette.grey.lightTint}`,
        borderRight: `1px solid ${palette.grey.lightTint}`,
        borderBottom: 'none',
        borderLeft: `1px solid ${palette.grey.lightTint}`,
        marginRight: spacing(0.25),
        borderRadius: spacing(1, 1, 0, 0),
        cursor: 'pointer',
        transition: 'all 0.2s linear',
        '&:hover': {
            backgroundColor: palette.secondary.dark,
            color: palette.secondary.contrastText,
            borderColor: palette.secondary.main,
        },
        '&:focus': {
            outline: 0,
        },
    },
    tabSelected: {
        color: palette.primary.contrastText,
        backgroundColor: palette.secondary.main,
        borderColor: palette.secondary.main,
    },
    icon: {
        marginRight: spacing(),
    },
}));
function Tab({ icon, value, selected, onClick }) {
    const classes = useStyles();
    return (React.createElement("button", { onClick: onClick, type: "button", className: classNames(classes.tabRoot, {
            [classes.tabSelected]: selected,
        }) },
        cloneElement(icon, { size: 'medium', className: classes.icon }),
        value));
}
export default Tab;
//# sourceMappingURL=Tab.js.map